import { gql } from '@apollo/client';
export default gql`
  query getOperationFinancesDone($start: Date, $end: Date) {
    getOperationFinancesDone(start: $start, end: $end) {
      ok
      error
      count
      data {
        _id
        docNo

        time
        opType
        title
        desc

        costAmount
        total
        discount
        amount

        refNo
        refType

        invoiceitems
        attachments

        supplierId
        supplierName
        supplierNameAr

        customerId
        customerName
        customerNameAr

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
